// extracted by mini-css-extract-plugin
export default {"BgtWidget":"BgtWidget_BgtWidget__YNK-q","BgtContent":"BgtWidget_BgtContent__Fsi3H","BgtImg":"BgtWidget_BgtImg__wIuDO"};